import styled from "styled-components";
import { TextBold, TextMedium, TextRegular } from "../../styles/GlobalStyledComponents";
import { colors } from "../../styles/Colors";

interface CardSectionProps {
  canHide?: boolean;
}

interface CardListProps {
  $marginBottom?: boolean;
}
interface InfoMiniSpanProps {
  backgroundColor?: string;
}

export const CardsList = styled.div<CardListProps>`
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    @media (max-width: 850px){
      margin-bottom: ${(props) => props.$marginBottom ? '160px' : '0px'};
    }

    @media (max-width: 650px) {
      padding: 0 15px;
    }
`;

export const PaymentSelectText = styled(TextBold)`
  max-width: 700px;
  margin: 5px 0 4px;
  width: 100%;
  @media (max-width: 650px) {
    max-width: 600px;
    padding: 10px 15px 0px;
  }
`;

interface CardInputProps {
  borderColor?: string;
  backgroundColor?: string;
  selected?: boolean;
  cardPadding?: string;
  cardMargin?: string;
  noBorder?: boolean;
  height?: string;
  order?: number;
  hidden?: boolean;
}

export const CardInput = styled.div<CardInputProps>`
    display: ${props => props.hidden ? 'none' : 'flex'};
    width: 100%;
    height: ${(props) => props.height ? `${props.height}px` : 'auto'};
    max-width: 700px;
    margin: ${props => props.cardMargin ? props.cardMargin : '5px auto'};
    padding: ${props => props.cardPadding ? props.cardPadding : '15px'};
    border-radius: 16px;
    border: solid 1px ${props => props.selected && props.borderColor ? props.borderColor : colors.gray11};
    gap: 10px;
    cursor: pointer;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : props.theme.colors.white};
    order: ${props => props.order};

    @media (max-width: 650px) {
      max-width: 600px;
      padding: ${props => props.cardPadding ? props.cardPadding : '15px'};
    }
`;

export const CardInputGoogle = styled(CardInput)`
  padding: 0;
`

export const CheckboxContainer = styled.div`
  cursor: pointer;
`;

export const CheckboxContainerGoogle = styled(CheckboxContainer)`
  padding: 15px 0 15px 15px;
`;

export const CardColumn = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const CardColumnGoogle = styled(CardColumn)`
   margin-right: 5px;
`;

export const CardRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const CardRow2 = styled.div`
  width: 100%;
    display: flex;
    justify-content: space-between;
    `;

export const CardSection = styled.div<CardSectionProps>`
    display: flex;
    align-items: center;
    @media (max-width: 500px) {
      display: ${props => props.canHide ? 'none' : 'flex'};
    }
`;
export const SimulationAmount = styled(TextBold)`
  text-align: end;
  padding: 2px 0;

  @media (max-width: 650px) {
    padding: 0;
    font-size: 20px;
  }

`;
export const GooglePayLogWrapper = styled(CardSection)`
  height: 45px;
`;

export const ApplePayLogWrapper = styled(CardSection)`
  height: 25px;
`;
interface CardCheckboxProps {
  isPromotion?: boolean;
}
export const CardCheckbox = styled.input<CardCheckboxProps>`
  margin-right: 5px;
  width: 22px;
  height: 22px;
  appearance: none;
  border: solid 2px ${(props) => props.theme.colors.gray9};
  border-radius: 50%;
  cursor: pointer;

  &:checked {
    background-image: url("/optionCheckedRed.svg");
    background-repeat: no-repeat;
    background-position: center;
  }
`;

// export const CardTitle = styled(TextBold)``;

export const PriceCurrency = styled(TextRegular)`
    padding: 0 5px;
`;

export const CardIcon = styled.div`
    margin-left: 10px;
`;

export const PromotionIcon = styled(CardIcon)`
  background-color: ${props => props.theme.colors.red10};
  border-radius: 50px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const PaymentClick = styled.button`
  /* width: 315px; */
  width: 100%;
  /* margin-left: 22.5px; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 12px;
  background-color: ${props => props.theme.colors.red4};
  border-color: ${props => props.theme.colors.red4};
  color: ${props => props.theme.colors.white};
  flex-direction: row;
  border-radius: 10px;
  border-style: none;
  min-height: 50px;
  cursor: pointer;
  span {
    color: ${props => props.theme.colors.white};
  }
  :disabled {
    opacity: 0.5;
  }
`;

export const InitialAmountBox = styled.div`
  border-radius: 5px;
  margin-right: 8px;
`;

export const InitialAmount = styled(TextMedium)`
  text-decoration: line-through;
`;

/* PROMOTIONS */

export const PromotionCard2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* margin: 0.75rem 10rem; */
  width: 100%;
  border-radius: 15px;
  gap: 20px;
  background-color: cornsilk;
  @media screen and (min-width: 320px) and (max-width: 479px) {
    margin: 20px 15px 10px 15px;
  }
`;

export const InfoCardMiniSpan = styled.span<InfoMiniSpanProps>`
  display: grid;
  align-items: center;
  background-color: ${(props) => props.backgroundColor ?? colors.green10};
  padding: 8px;
  border-radius: 8px;
  /* max-height: 24px; */
  width: fit-content;
  place-self: end;

  @media (max-width: 420px) {
    place-self: start;
  }
`;

export const CardInfoSection = styled(CardSection)`
  padding: 0px;
`;

export const CardLabel = styled(TextBold)`
  display: flex;
  align-items: center;
  height: 8px;
  margin-top: 3px;
`;

